<template>
	<!-- 排行 -->
	<div class="soltBox">
		<!-- 强推排行 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(0)">
					<p class="btnLimite">强推排行</p>
					<div class="limiteArr">
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_qt">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 4 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_qt.length>2">
							<div  @click="toSoltDetail(0)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 完结金榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(1)">
					<p class="btnLimite">完结金榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_wj">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_wj.length>2">
							<div  @click="toSoltDetail(1)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 萌新榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(2)">
					<p class="btnLimite">萌新榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_mx">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_mx.length>2">
							<div  @click="toSoltDetail(2)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 月榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(3)">
					<p class="btnLimite">月榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_yue">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_yue.length>2">
							<div  @click="toSoltDetail(3)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 季榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(4)">
					<p class="btnLimite">季榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_ji">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_ji.length>2">
							<div  @click="toSoltDetail(4)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 云尼斯榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(5)">
					<p class="btnLimite">云尼斯榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_yns">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_yns.length>2">
							<div  @click="toSoltDetail(5)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 金云朵榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(6)">
					<p class="btnLimite">金云朵榜 </p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_jyd">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_jyd.length>2">
							<div  @click="toSoltDetail(6)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 勤奋修仙榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(7)">
					<p class="btnLimite">勤奋修仙榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_qfxx">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_qfxx.length>2">
							<div  @click="toSoltDetail(7)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- VIP新文总榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(8)">
					<p class="btnLimite">VIP新文总榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_vip">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_vip.length>2">
							<div  @click="toSoltDetail(8)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- 收入金榜 -->
		<div class="soltPhItemBox">
			<div class="yunjin_jbBox">
				<div class="limiteFooter" @click="toSoltDetail(9)">
					<p class="btnLimite">收入金榜</p>
						<div class="limiteArr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(rankitem,index) in ranking_sr">
							<div @click='toDetail(rankitem.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + rankitem.cover_image" alt="">
								</div>
								<p class="jianjie"><span v-for="(introduce,introduceIndex) in rankitem.introduce" v-if="introduceIndex > 7 ? false : true">{{introduce}}</span></p>
								<!-- <p class="bookName"><span v-for="(books_name,bookNameIndex) in rankitem.book_name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p> -->
							</div>
						</swiper-slide>
						<swiper-slide v-if="ranking_sr.length>2">
							<div  @click="toSoltDetail(9)">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				jb_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				ranking_qt: [],
				ranking_jyd: [],
				ranking_ji: [],
				ranking_mx: [],
				ranking_qfxx: [],
				ranking_sr: [],
				ranking_vip: [],
				ranking_wj: [],
				ranking_yns: [],
				ranking_yue: []
			}
		},
		created() {
			this.get_ranking_index()
		},
		methods: {
			get_ranking_index() {
				this.$axios.post(this.$api.ranking_index).then(res => {
					console.log(res, '排行')
					if (res.status == 200) {
						if (res.data.data.length != 0) {
							this.ranking_qt = res.data.data.ranking_qt;



							console.log(this.ranking_qt);
							this.ranking_jyd = res.data.data.ranking_jyd;
							this.ranking_ji = res.data.data.ranking_ji;
							this.ranking_mx = res.data.data.ranking_mx;
							this.ranking_qfxx = res.data.data.ranking_qfxx;
							this.ranking_sr = res.data.data.ranking_sr;
							this.ranking_vip = res.data.data.ranking_vip;
							this.ranking_wj = res.data.data.ranking_wj;
							this.ranking_yns = res.data.data.ranking_yns;
							this.ranking_yue = res.data.data.ranking_yue;
						}
					}

				})
			},
			// 跳详情
			toDetail(val) {
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						getSecond_tab: 2,
						getFirstvalue_tab: 0,
						url: 'soltPh01',
					}
				})
			},
			//跳转排行子页面
			toSoltDetail(i) {
				this.$router.push({
					path: '/soltPhDetail',
					query: {
						index: i,
						url: 'soltPh'
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.soltPhItemBox {
		padding: 0 16px;
		background-color: #fff;
	}

	.soltPhItemBox:last-child {
		border-bottom: 0;
	}

	.soltBox {
		padding-top: 60px;
		background-color: #fff;
		overflow-y: scroll;
		height: calc(100vh - 220px);
	}

	// 云锦金榜
	.yunjin_jbBox {
		// height: 320px;
		border-bottom: 1px solid #f0f0f0;
		/*no*/
		padding: 20px 0px;
		padding-top: 0;

		.limiteFooter {
			display: flex;
			justify-content: space-between;
			background-color: #fff;
			line-height: 80px;
			position: relative;

			.btnLimite {
				font-size: 30px;
				/*px*/
				color: #ff4081;
				font-weight: 700;
				// transform: scale(1.1);
			}

			.limiteArr {
				img {
					width: 50px;
					position: absolute;
					top: 50%;
					right: 0;
					transform: translateY(-50%);
				}
			}
		}

		.yunjin_jb {
			margin-top: 10px;
			// height: 360px !important;
		
			.swiper-container {
				height: 100%;
		
				.swiper-slide {
					width: 28% !important;
					margin-right: 15px !important;
						div{
							text-align: center;
							img {
								vertical-align: middle;
								width: 190px;
								height: 270px;/*px*/
								-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
								/*no*/
								-moz-box-shadow:  0 3px 3px 0 rgba(0, 0, 0, .3);
								/*no*/
								box-shadow:  0 3px 3px 0 rgba(0, 0, 0, .3);
								/*no*/
							}
						}
		
					.bookImg {
						position: relative;
		
						.bookState {
							position: absolute;
							top: 10px;
							right: 6%;
							// border-top-left-radius: 30px;
							// border-bottom-left-radius: 30px;
							padding-left: 15px;
							padding-right: 10px;
							font-size: 22px;
							/*px*/
							color: #fff;
						}
					}
		
					.bookName {
						font-size: 30px;
						/*px*/
						overflow: hidden;
						white-space: nowrap;
						// text-overflow: ellipsis;
						padding-top: 15px;
						color: #000;
						text-align: center;
					}
		
					.jianjie {
						font-size: 24px;
						/*px*/
						color: #000;
						padding-top: 15px;
						opacity: 0.6;
					}
				}
			}
		}
	}
</style>
